import React from 'react';
import ReactDOM from 'react-dom';
import Loader from './Loader.js';
import Feed from './buildFeed.js';
import {parseString} from 'xml2js'


class News extends React.Component {
  	constructor(props) {
		super(props);
    	this.state = { isLoading: true,datasource: [] }
	}

	componentDidMount(){


		  this._isMounted = true;
		  var url = "https://rss.app/feeds/_6QbfFajeZ2kSeYEg.xml";
			var result = [];
		  fetch(url)
		    .then((response) => response.text())
		    .then((responseText) => {
		   parseString(responseText, (err, result) => {
		     this.setState({
		    	datasource : result.rss.channel[0].item,isLoading: false
		    })
		     return result;
		    });
		  	 this._isMounted = false;
		   })
		.catch((error) => {

		  console.log('Error fetching the feed: ', error);
		});
	  }
	
	componentWillUnmount() {
         this._isMounted = false;
      }

	render() {
		var res = this.state.datasource;
		
			var resLength = res.length;
			console.log(res);
			if(resLength > 1) {
				return(
				
					this.state.isLoading ? <Loader /> : <Feed items={res} />
				)	
			} else {
				return(
				
					this.state.isLoading ? <Loader /> : <div className="">No news Found</div>
				)
			}
	 	}
		
		 
		
	
}

export default News;
